// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_Gds","cls2":"ClaimDetails-cls2_Ws3 ClaimDetails-cls1_Gds"};